<!--
 * @Author: your name
 * @Date: 2021-04-13 09:47:14
 * @LastEditTime: 2021-04-16 10:23:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ecmp5-client-web/src/views/user/receipt/Container.vue
-->
<template>
  <van-sticky>
  <div class="nav-container">
    <div class="header">
      <img class="back" src="@/images/receipt_back.png" @click="goBack" />
      发票
    </div>
  </div>

  <div class="container">
    <div class="item-list">
      <div class="item-title" @click="openReceipt">
        <img src="@/images/open_receipt_icon.png" class="title-icon" />
        <div class="t-f14-cff">开票</div>
      </div>
      <div class="item-title" @click="toRecord">
        <img src="@/images/receipt_record_icon.png" class="title-icon" />
        <div class="t-f14-cff">开票记录</div>
      </div>
      <div class="item-title" @click="toTitleContainer">
        <img src="@/images/receipt_title_icon.png" class="title-icon" />
        <div class="t-f14-cff">抬头管理</div>
      </div>
    </div>
  </div>
  </van-sticky>
  <!-- 运营商列表  -->
  <div class="list-container">
    <div v-for="item in state.providerList" :key="item" @click="toProviderList(item.service_provider.id)">
      <div class="order-item">
        <img
          src="@/images/operator_defult_logo.png"
          class="logo-icon"
        />
        <div class="m-l-10">
          <span class="t-f16-c1a font-bold">{{item.service_provider.name}}</span>
          <div class="t-f14-c99">包含 {{item.total_count}} 个发票</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import request from "@/api/request";
import { reactive } from "vue";
let router;
let state = reactive({
  providerList: [],
});
export default {
  setup() {
    router = useRouter();

    return { goBack, openReceipt, toRecord, toTitleContainer,toProviderList,state };
  },
  created() {
    this.apiInvoiceOfProvier();
  },
  methods: {
    //request list data
    apiInvoiceOfProvier() {
      request.getInvoiceOfProvider().then((res) => {
        state.providerList = res.data.results;
      });
      //  .catch( error=>{
      //  })
    },
  },
};

function goBack() {
  router.back();
}
//开票
function openReceipt() {
  router.push("/user/receipt/index_list");
}
//发票记录
function toRecord() {
  router.push("/user/receipt/receipt_record");
}
//抬头管理
function toTitleContainer() {
  router.push("/user/receipt/title_list");
}
function toProviderList(id){
  router.push(`/user/receipt/receipt_record/${id}`);
}
</script>

<style scoped>
.logo-icon {
  width: 44px;
  height: 44px;
}
.order-item {
  background: #fff;
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  align-items: center;
  padding: 15px;
  margin-bottom:10px ;
}
.list-container {
  margin: 10px;
}
.container {
  background: linear-gradient(to right, #6ab7ff, #0082ff);
  padding-bottom: 20px;
}
.item-list {
  display: flex;
}
.item-title {
  margin-top: 20px;
  flex: 1;
  text-align: center;
}
.title-icon {
  width: 36px;
  height: 36px;
}
.header {
  height: 45px;
  background: linear-gradient(to right, #6ab7ff, #0082ff);
  font-size: 18px;
  color: #fff;
  text-align: center;
  line-height: 45px;
  position: relative;
}

.back {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
}

</style>